module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/16-baab19b5b6a6802ba557a5568e483692.webm";